import { es } from '@braid/vue-formulate-i18n';
import FormulateVuePhonePlugin from '@/funnels/components/form/phone';
import VueFormulateDatepickerPlugin from 'vue-formulate-datepicker';
import TriotecaDatepickerPlugin from '@/funnels/components/form/datepicker';
import TriotecaSelectPlugin from '@/funnels/components/form/triotecaSelect';
import CustomInputRules from '@/lego/plugins/rules';

export default [es, FormulateVuePhonePlugin, VueFormulateDatepickerPlugin, TriotecaDatepickerPlugin, TriotecaSelectPlugin, CustomInputRules];
